import { hasMany } from '@warp-drive/legacy/model';
import DigitalAsset from './digital-asset.ts';
import type EmployeeModel from './employee.ts';
import type PslfProfileModel from './pslf-profile.ts';
import type PslfTemplateModel from './pslf-template.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class PslfAsset extends DigitalAsset {
  @hasMany('employee', { async: false, inverse: 'pslfAssets' })
  declare employees: EmployeeModel[];
  @hasMany('pslf-profile', { async: false, inverse: 'pslfAssets' })
  declare pslfProfiles: PslfProfileModel[];
  @hasMany('pslf-template', { async: false, inverse: 'pslfAssets' })
  declare pslfTemplates: PslfTemplateModel[];

  [Type] = 'pslf-asset' as const;
}
